<template>
    <div>
        <Breadcrumb section-name="Income" :breadcrumb="breadCrumb" :btn-name="null"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="manage">
                        <div class="fixed-card-height">
                            <div class="card border-top border-0 border-4 border-primary">
                                <div class="card-body p-4">
                                    <div class="card-title d-flex align-items-center justify-content-between mb-0">
                                        <h5 class="mb-0 text-primary">{{ breadCrumb[0] }} Income</h5>
                                    </div>
                                    <hr>
                                    <div class="row g-3">
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Project <span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="addEditParam.project_id" name="project_id">
                                                <option value="">Select Project</option>
                                                <option v-for="c in projects" :key="c.id" :value="c.id">{{ c.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Date <span class="text-danger">*</span></label>
                                            <flat-pickr class="form-control" v-model="addEditParam.date" name="date"
                                                        :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"
                                                        placeholder="Select Date"/>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Category</label>
                                            <select class="form-select" v-model="addEditParam.income_category_id" name="income_category_id">
                                                <option value="">Select Category</option>
                                                <option v-for="b in incomeCategories" :key="b.id" :value="b.id">{{ b.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Payment Method <span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="addEditParam.payment_method" name="payment_method">
                                                <option value="">Select Payment Method</option>
                                                <option v-for="each in assets" :key="each.slug" :value="each.slug">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group" v-if="addEditParam.payment_method === 'bank'">
                                            <label class="form-label">Bank Name</label>
                                            <select class="form-select" v-model="addEditParam.bank_id" name="bank_id">
                                                <option value="">Select Bank</option>
                                                <option v-for="b in banks" :key="b.id" :value="b.id">{{ b.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group" v-if="addEditParam.payment_method === 'bank'">
                                            <label class="form-label">Check Number</label>
                                            <input type="text" class="form-control" name="check_number" v-model="addEditParam.check_number" placeholder="Enter check number">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Deposit By <span class="text-danger">*</span></label>
                                            <select class="form-select" v-model="addEditParam.deposit_by" name="deposit_by" :disabled="!addEditParam.project_id">
                                                <option value="">{{ addEditParam.project_id ? 'Select Deposit By' : 'Select project first' }}</option>
                                                <option v-for="member in shareholders" :key="member.id" :value="member.id">{{ member.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Amount <span class="text-danger">*</span></label>
                                            <input type="text" class="form-control" v-model="addEditParam.amount" name="amount" placeholder="Enter amount">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Cash Received By</label>
                                            <select class="form-select" v-model="addEditParam.cash_received_by" name="cash_received_by">
                                                <option value="">Select Cash Received By</option>
                                                <option v-for="b in cashReceived" :key="b.id" :value="b.id">{{ b.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Costing Item</label>
                                            <select class="form-select" v-model="addEditParam.costing_item_id" name="costing_item_id">
                                                <option value="">Select Costing Item</option>
                                                <option v-for="each in costingItem" :key="each.id" :value="each.id">{{ each.name }}</option>
                                            </select>
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Attachment</label>
                                            <input type="file" class="form-control" @change="addAttachment">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <label class="form-label">Remarks</label>
                                            <input type="text" class="form-control" v-model="addEditParam.remarks" name="remarks" placeholder="Enter remarks">
                                            <small class="invalid-feedback text-danger"></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end gap-2 mt-3">
                            <router-link :to="{name: 'income'}" class="btn btn-secondary btn-width">Close</router-link>
                            <button type="submit" class="btn btn-primary btn-width" v-if="!loading">Update</button>
                            <button type="button" class="btn btn-primary btn-width" v-else disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    components: {Breadcrumb},
    data() {
        return {
            breadCrumb: ['Edit'],
            loading: false,
            dataLoading: false,
            addEditParam: {
                project_id: '',
                date: '',
                payment_method: '',
                bank_id: '',
                check_number: '',
                deposit_by: '',
                amount: '',
                attachment: '',
                income_category_id: '',
                cash_received_by: '',
                remarks: '',
                costing_item_id: ''
            },
            shareholders: [],
            banks: [],
            projects: [],
            assets: [],
            incomeCategories: [],
            cashReceived: [],
            costingItem: []
        }
    },
    watch: {
        'addEditParam.project_id'(projectId, oldProjectId) {
            if (oldProjectId !== undefined && oldProjectId !== '' && String(oldProjectId) !== String(projectId)) {
                this.addEditParam.deposit_by = '';
            }
            this.fetchShareholdersByProject(projectId);
        }
    },
    methods: {
        fetchShareholdersByProject(projectId) {
            if (!projectId) {
                this.shareholders = [];
                return;
            }
            ApiService.POST(ApiRoutes.ShareHolder + '/search', {project_id: projectId}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.shareholders = res.data;
                }
            });
        },
        fetchCostingItem() {
            ApiService.POST(ApiRoutes.CostingItem + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.costingItem = res.data.data;
                }
            });
        },
        fetchCashReceivedBy() {
            ApiService.POST(ApiRoutes.CashReceived + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.cashReceived = res.data.data;
                }
            });
        },
        fetchSingleIncome() {
            ApiService.POST(ApiRoutes.Income + '/single', {id: this.$route.params.id}, (res) => {
                this.addEditParam = res.data;
            });
        },
        fetchAssets() {
            ApiService.POST(ApiRoutes.Asset + '/list', {}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.assets = res.data;
                }
            });
        },
        makeFormData(object) {
            let formData = new FormData();
            for (const property in object) {
                if (object[property] !== null && object[property] !== '') {
                    formData.append(property, object[property]);
                }
            }
            return formData;
        },
        addAttachment(e) {
            this.addEditParam.attachment = e.target.files[0];
        },
        fetchBank() {
            ApiService.POST(ApiRoutes.Bank + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.banks = res.data.data;
                }
            });
        },
        fetchIncomeCategory() {
            ApiService.POST(ApiRoutes.IncomeCategory + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.incomeCategories = res.data.data;
                }
            });
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        manage() {
            ApiService.ClearErrorHandler();
            this.loading = true;
            let param = this.makeFormData(this.addEditParam);
            ApiService.POST(ApiRoutes.Income + '/update', param, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.$router.push({name: 'income'});
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        }
    },
    created() {
        this.fetchSingleIncome();
        this.fetchProject();
        this.fetchBank();
        this.fetchAssets();
        this.fetchIncomeCategory();
        this.fetchCashReceivedBy();
        this.fetchCostingItem();
    }
}
</script>
